import styles from "./Spinner.module.css";

/**
 * The branded RWS spinner, drawn inline so it needs no request: it still turns when the server it is
 * waiting for is down, which is exactly when the old `/brand/spinner-rws.gif` failed to load. It is the
 * GIF redrawn: a pink and a blue dot take turns to slide left to right, and the dot that has arrived
 * shrinks away and grows back on the left. Each dot is drawn twice, as the one that slides and the one
 * that shrinks, so the sliding dots can sit on top without the drawing order having to change.
 *
 * Decorative: the text beside it says what is loading.
 */
export function Spinner(): React.JSX.Element {
  return (
    <svg className={styles.spinner} viewBox="0 0 55 55" aria-hidden="true" focusable="false">
      <circle className={`${styles.dot} ${styles.grow} ${styles.pink}`} cx="16" cy="27.5" r="10.5" />
      <circle className={`${styles.dot} ${styles.grow} ${styles.blue}`} cx="16" cy="27.5" r="10.5" />
      <circle className={`${styles.dot} ${styles.slide} ${styles.pink}`} cx="16" cy="27.5" r="10.5" />
      <circle className={`${styles.dot} ${styles.slide} ${styles.blue}`} cx="16" cy="27.5" r="10.5" />
    </svg>
  );
}
